import { Box, makeStyles, Theme } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import Close from "@material-ui/icons/Close";
import React, { useEffect, useState } from "react";
interface IProps {
  open: boolean;
  withoutStyleAndClose?: boolean;
  withoutStyle?: boolean;
  withoutPaddingContent?: boolean;
  content: any;
  close(event: any): void;
  width?: string;
  mobileWidth?: string;
  height?: string;
  overflow?: any;
  classNames?: any;
  background?: string;
}

const TextInput: React.FC<IProps> = ({
  open,
  withoutStyleAndClose,
  withoutStyle,
  withoutPaddingContent,
  content,
  close,
  width,
  mobileWidth,
  height,
  overflow,
  classNames,
  background,
}) => {
  const [windowDimensions, setWindowDimensions] = useState(window.innerWidth);
  useEffect(() => {
    const root = document.getElementById("root");
    const body = document.getElementById("body_id");
    if (!!root) {
      root.style.overflowY = "hidden";
    }
    if (!!body) {
      body.style.overflowY = "hidden";
    }
    function handleResize() {
      setWindowDimensions(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const Styles = makeStyles((theme: Theme) => ({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& >div": {
        zIndex: 99999999,
      },
    },
    paper: {
      position: "absolute",
      width:
        windowDimensions > 500
          ? !!width
            ? width
            : 450
          : !!mobileWidth
          ? mobileWidth
          : "99%",
      maxWidth: "92%",
      maxHeight: !!height ? height : "100%",
      overflowY: !!overflow ? overflow : "auto",
      overflowX: "hidden",
      backgroundColor: !!background ? background : theme.customColors.childBack,
      boxShadow: theme.shadows[5],
      padding:
        !!withoutStyleAndClose && withoutStyleAndClose
          ? ""
          : theme.spacing(1, 4, 4),
      direction: "rtl",
      borderRadius: !!withoutStyle && withoutStyle ? "0" : "15px",
      outline: "none",
    },
    content: {
      backgroundColor: !!background ? background : theme.customColors.childBack,
      padding:
        !!withoutPaddingContent && withoutPaddingContent
          ? "0"
          : windowDimensions > 700
          ? theme.spacing(2, 4, 3)
          : "10px",
      direction: "ltr",
    },
    icon: {
      color: theme.customColors.title,
      cursor: "pointer",
    },
  }));
  const classes = Styles();
  React.useEffect(() => {}, [open]);
  return (
    <Modal
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      open={open}
      onClose={(event: any) => {
        const root = document.getElementById("root");
        const body = document.getElementById("body_id");
        if (!!root) {
          root.style.overflowY = "scroll";
        }
        if (!!body) {
          body.style.overflowY = "scroll";
        }
        close(event);
      }}
      className={classes.modal}
      style={{
        zIndex: 1300,
      }}
    >
      <Fade in={open}>
        <Box
          className={[classes.paper, classNames].join(" ")}
          sx={{ padding: { xs: "0 !important", sm: "0 !important" } }}
        >
          <div className={classes.content}>
            {!!withoutStyleAndClose && withoutStyleAndClose ? (
              ""
            ) : (
              <div className="row justify-content-center">
                <div className="col-12 pb-1 pr-4 pt-3">
                  <Close onClick={close} className={classes.icon} />
                </div>
              </div>
            )}
            {content}
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default TextInput;
